<template>
  <div class="test"></div>
</template>

<script>
  export default {
    props: {
      //服务端地址如：ws://127.0.0.0:8080,由后端建立的WebSocket地址
      url: {
        require: true,
        type: String
      },
    },
    data() {
      return {
        WebSocket: null, //WebSocket实例
      }
    },
    mounted() {
      this.init()
      let _this = this
      window.onbeforeunload = (e) => {
        _this.WebSocket.close()
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return '关闭提示';
      };
    },
    destroyed() {
      this.WebSocket.close()
    },
    methods: {
      init() {
        //创建WebSocket实例
        this.WebSocket = new WebSocket(this.url)
        this.WebSocket.onopen = this.onopen
        this.WebSocket.onerror = this.onerror
        this.WebSocket.onmessage = this.onmessage
        this.WebSocket.onclose = this.onclose
      },
      //连接成功触发
      onopen(e) {
        console.log('连接成功')
      },
      //连接失败触发
      onerror(e) {
        console.log('连接失败')
      },
      //接收服务端消息
      onmessage(e) {
        console.log('接收到消息')
        this.$emit('on-message', e.data)
      },
      //连接关闭时触发
      onclose(e) {
        console.log('连接已关闭')
      },
      //发送消息
      send_message(msg) {
        this.WebSocket.send(msg||'有新消息来啦')
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/public/WebSocket.vue